module.exports = __webpack_public_path__ + "media/ThinClick.8ea6b489.wav";